import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import { vars } from '~/styles/theme.css'
import { invertColor } from '~/utils'
import {
  badge,
  badgeCircle,
  badgeClickable,
  badgeReverse,
  badgeText
} from './Badge.css'

interface BadgeItemProps {
  title: string
  icon?: IconDefinition
  backgroundColor: string
  badgeClass?: string
  reverse?: boolean
  maxWidth?: number
  minWidth?: number
  onClick?: () => void
  style?: React.CSSProperties
}

export const Badge = ({
  title,
  icon,
  backgroundColor,
  badgeClass,
  reverse,
  maxWidth,
  minWidth,
  onClick
}: BadgeItemProps): ReactElement => {
  return (
    <span
      className={clsx(
        badge,
        reverse ? badgeReverse : null,
        badgeClass,
        onClick ? badgeClickable : null
      )}
      title={title}
      onClick={onClick}
      style={{
        maxWidth: maxWidth ? `${maxWidth}px` : 'none',
        minWidth: minWidth ? `${minWidth}px` : 'none'
      }}
    >
      <span
        className={badgeCircle}
        style={{
          backgroundColor: backgroundColor,
          ...(icon &&
            backgroundColor.startsWith('#') && {
              color: invertColor(
                backgroundColor,
                vars.color.mediumDarker,
                vars.color.white
              )
            })
        }}
      >
        {icon && <FontAwesomeIcon icon={icon} />}
      </span>
      <span className={badgeText}>{title}</span>
    </span>
  )
}
